module.exports = __webpack_public_path__ + "img/el-diablo.22f4165f.jpg";